(function () {
  "use strict";

  var page = document.querySelector("[data-bf-page]");
  if (!page) return;

  var previewNow = Number(page.getAttribute("data-bf-now") || 0);
  var skew = previewNow ? previewNow * 1000 - Date.now() : 0;

  function nowMs() {
    return Date.now() + skew;
  }

  function unitWord(n, one, many) {
    return n === 1 ? one : many;
  }

  function paint(el) {
    var ends = Number(el.getAttribute("data-bf-ends"));
    if (!ends) return;
    var ms = ends * 1000 - nowMs();
    if (ms < 0) ms = 0;
    var total = Math.floor(ms / 1000);
    var days = Math.floor(total / 86400);
    var hours = Math.floor((total % 86400) / 3600);
    var minutes = Math.floor((total % 3600) / 60);
    var seconds = total % 60;
    var mode = el.getAttribute("data-bf-mode");

    if (mode === "hours") {
      var totalHours = days * 24 + hours;
      var hourWord = unitWord(totalHours, "hour", "hours");
      var minuteWord = unitWord(minutes, "minute", "minutes");
      var secondWord = unitWord(seconds, "second", "seconds");
      var sentence;
      var visual;
      if (totalHours >= 1) {
        sentence = totalHours + " " + hourWord + " and " + minutes + " " + minuteWord + " remaining";
        visual = totalHours + " " + hourWord + " remaining";
      } else {
        sentence = minutes + " " + minuteWord + " and " + seconds + " " + secondWord + " remaining";
        visual = minutes + " " + minuteWord + " remaining";
      }
      el.setAttribute("aria-label", sentence);
      var visualEl = el.querySelector("[data-bf-visual]");
      if (visualEl) visualEl.textContent = visual;
      return;
    }

    var dayWord = unitWord(days, "day", "days");
    var hourWordFull = unitWord(hours, "hour", "hours");
    var minWord = unitWord(minutes, "minute", "minutes");
    var secWord = unitWord(seconds, "second", "seconds");
    var daysEl = el.querySelector("[data-bf-days]");
    var hoursEl = el.querySelector("[data-bf-hours]");
    var minsEl = el.querySelector("[data-bf-mins]");
    var secsEl = el.querySelector("[data-bf-secs]");
    var daysLabel = el.querySelector("[data-bf-days-label]");
    var hoursLabel = el.querySelector("[data-bf-hours-label]");
    var minsLabel = el.querySelector("[data-bf-mins-label]");
    var secsLabel = el.querySelector("[data-bf-secs-label]");
    if (daysEl) daysEl.textContent = String(days);
    if (hoursEl) hoursEl.textContent = String(hours);
    if (minsEl) minsEl.textContent = String(minutes);
    if (secsEl) secsEl.textContent = String(seconds);
    if (daysLabel) daysLabel.textContent = dayWord;
    if (hoursLabel) hoursLabel.textContent = hourWordFull;
    if (minsLabel) minsLabel.textContent = minWord;
    if (secsLabel) secsLabel.textContent = secWord;
    el.setAttribute(
      "aria-label",
      days + " " + dayWord + ", " + hours + " " + hourWordFull + ", " + minutes + " " + minWord + " and " + seconds + " " + secWord + " remaining"
    );
    if (total === 0) el.hidden = true;
  }

  var roots = page.querySelectorAll("[data-bf-count]");

  function paintAll() {
    for (var i = 0; i < roots.length; i++) paint(roots[i]);
  }

  function arm() {
    paintAll();
    var delay = 1000 - (nowMs() % 1000);
    window.setTimeout(arm, delay);
    if (!page.hasAttribute("data-bf-now")) {
      var boundary = Number(page.getAttribute("data-bf-boundary") || 0);
      if (boundary && nowMs() >= boundary * 1000) {
        var key = "bf-boundary-" + boundary;
        try {
          if (window.sessionStorage.getItem(key) === "1") return;
          window.sessionStorage.setItem(key, "1");
        } catch (error) {}
        window.location.reload();
      }
    }
  }

  if (roots.length) {
    arm();
    document.addEventListener("visibilitychange", function () {
      if (!document.hidden) paintAll();
    });
  }

  var forms = page.querySelectorAll(".bf-form");
  for (var f = 0; f < forms.length; f++) {
    forms[f].addEventListener("submit", function (event) {
      var button = event.currentTarget.querySelector('[type="submit"]');
      if (button) button.disabled = true;
    });
  }

  var finePointer = window.matchMedia("(hover: hover) and (pointer: fine)").matches;
  var cards = page.querySelectorAll(".bf-day--has-back");
  for (var c = 0; c < cards.length; c++) {
    (function (card) {
      var back = card.querySelector(".bf-day__back");
      var front = card.querySelector(".bf-day__front");
      if (!back) return;
      if (!finePointer) {
        if (card.classList.contains("bf-day--closed")) back.removeAttribute("aria-hidden");
        return;
      }
      function showBack() {
        back.removeAttribute("aria-hidden");
        if (front) front.setAttribute("aria-hidden", "true");
      }
      function showFront() {
        if (card.matches(":hover") || card.matches(":focus-within")) return;
        back.setAttribute("aria-hidden", "true");
        if (front) front.removeAttribute("aria-hidden");
      }
      card.addEventListener("mouseenter", showBack);
      card.addEventListener("mouseleave", showFront);
      card.addEventListener("focusin", showBack);
      card.addEventListener("focus", showBack);
      card.addEventListener("focusout", showFront);
      card.addEventListener("blur", showFront);
    })(cards[c]);
  }
})();
